import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { INewProfileInputDto, IProfileDto } from "../types/Types";

/**
 * @author mb
 */
export const ErrorAPI = createApi({
    reducerPath: "errorAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "error",
            credentials: 'include'
        }),
    tagTypes: ['errorAPI'], // for caching
    endpoints: (builder) => ({
        /*getProfiles: builder.mutation<IProfileDto[], void>(
            {
                query: () => ({
                    url: '',
                    method: 'get',
                    params: {
                        
                    },
                    credentials: 'include'
                })
            }
        ),
        getProfile: builder.mutation<IProfileDto, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        deleteProfile: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: `` + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),*/
        createLog: builder.mutation<void, { status: string, api: string,message: string }>(
            {
                query: (dto) => ({
                    url: `log`,
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
       
       
    })
});

export const {
    
    useCreateLogMutation,
    
} = ErrorAPI;
